import { MutationTree } from 'vuex';

import { subscribableStore } from './common';
import { TimestampsGpsState } from './types';

const mutations: MutationTree<TimestampsGpsState> = {
  ...subscribableStore.mutations,
};

export default mutations;
